/* import __COLOCATED_TEMPLATE__ from './dialog-header.hbs'; */
/**

## Dialog header

The <code>dialog-header</code> component is designed to be used as a contextual component of one of the dialog components:
[dialog-modal](/components/glass/dialog-modal.html), [dialog-blade](/components/glass/dialog-blade.html), or [dialog-sheet](/components/glass/dialog-sheet.html).

### Parameters
@param {String} [title] required. The title is shown in the center of the heading.
@param {Action/Component} [close] optional. A link-to component (or action if no route transition) that handles the clicking of the <code>x</code> button in the header. If not provided, a <code>secondary-actions</code> contextual component will be yielded out that provides buttons/icons you can use for secondary actions.
@param {String} [context] Determines the parent context in which this header is shown, which applies appropriate class name bindings.

**/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { CONTEXT } from '../utils/dialog-actions';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  title: null,
  tagName: 'header',
  classNames: ['dialog__header'],
  classNameBindings: ['contextClass'],
  contextClass: computed('context', function () {
    switch (this.get('context')) {
      case CONTEXT.BLADE:
        return 'dialog--blade__header';
      case CONTEXT.MODAL:
        return 'dialog--modal__header';
      case CONTEXT.SHEET:
        return 'dialog--sheet__header';
      default:
        return '';
    }
  }),
  isCloseComponent: computed('close', function () {
    // For detecting a link-to component which can handle the route transition for closing the blade.
    return typeof this.get('close') === 'object';
  })
});